import React, {useEffect, useState} from 'react';
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../components/recoil/atoms/Menus";

import Footer from "./components/includes/Footer";
import AgreeCondition from "./components/popups/AgreeCondition";
import PopupConditions from "./components/popups/PopupConditions";
import SelectChildrens from "./components/popups/SelectChildrens";
import { unescapeHtml,GetShotDateString,isNull,LoginAfterCheckLogin,isObjEmpty,GetClassStudyMode,GetMonthDateString } from '../components/common/Common';
import "../css/style.css";

import centerIcon from "../img/icon/icon-center.svg";
import changeIcon from "../img/icon/icon-us-change.svg";
import class1Icon from "../img/icon/icon-class01.svg";
import class2Icon from "../img/icon/icon-class02.svg";
import class3Icon from "../img/icon/icon-class03.svg";

const MainParent = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검
  const mem_idx = Number(localStorage.getItem('mem_idx'));
  const navigate = useNavigate();
  const [varParentsMenus,setParentsMenus] = useRecoilState(ParentsMenus);

  //정보저장변수
  const [varChildrenInfo,setChildrenInfo] = useState({});
  const [varChildrenList,setChildrenList] = useState([]);
  const [varChildrenIndex,setChildrenIndex] = useState(-1);

  const [varMainList,setMainList] = useState([]);
  const [varNoticeList,setNoticeList] = useState([]);

  //팝업창
  const [varPopupAgreeWin,setPopupAgreeWin] = useState(false);
  const [varPopupChildrens,setPopupChildrens] = useState(false);
  
  //정보호출
  const GetMainInformation = async() => {
    const sendData = {mem_idx:mem_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_main_imformation`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0) {
          const parents = datas.results;

          //자녀(원생) 목록
          setChildrenList(parents);
          
          //원생 선택
          //console.log(varChildrenIndex);
          let childInfo = {};
          if(varChildrenIndex > 0) childInfo = parents.find(el=>el.ch_idx===varChildrenIndex);

          let changeIndex = false;
          if(isObjEmpty(childInfo)) {
            childInfo = parents[0];
            if(childInfo.ch_idx !== varChildrenIndex) {
              changeIndex = true;
              setChildrenIndex(childInfo.ch_idx);
              localStorage.setItem('childrenIndex',childInfo.ch_idx);
            }
          }
          console.log(childInfo);
          setChildrenInfo(childInfo);

          //약관 동의가 없으면
          if(parents[0].term_condition === 0) {
            setPopupAgreeWin(true);
          };
          //원생 변경이 없으면
          if(!changeIndex) GetClassList(childInfo.ch_idx);
        }
      } else {
        alert(datas.message);
      }
    });
  }

  //학기내역 가져오기
  const GetClassList = async(ch_idx) => {
    const sendData = {ch_idx:ch_idx,cl_state:1};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_main_class_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //공지사항
        setNoticeList(datas.notices);
        //클래스내역
        if(datas.results.length > 0){
          const classes = datas.results;
          let classList = [];
          for(var i=0; i<classes.length; i++) {
            let classData = datas.results[i];
            classList.push(classData);
          }
          setMainList(classList);
        } else {
          setMainList([]);
        }
      } else {
        setMainList([]);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    console.log(varParentsMenus);
    setParentsMenus({showMenu:true,gotoMain:-1});
    //선택된 원생번호
    let ch_idx = 0;
    if(!isNull(localStorage.getItem('childrenIndex'))) ch_idx = Number(localStorage.getItem('childrenIndex'));
    setChildrenIndex(ch_idx);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log(varChildrenIndex,varChildrenList);
    if(varChildrenIndex >= 0) {
      if(varChildrenIndex === 0 || varChildrenList.length === 0){
        GetMainInformation();
      } else {
        let childInfo = varChildrenList.find(el=>el.ch_idx===varChildrenIndex);
        setChildrenInfo(childInfo);
        GetClassList(varChildrenIndex);
      } 
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varChildrenIndex]);

  //약관보기
  const [varPopupConditionWin,setPopupConditionWin] = useState(false);
  const [varConditionItem,setConditionItem] = useState(0);
  const onPopupConditionHandler = (e,itype) => {
    setPopupAgreeWin(false);
    setConditionItem(itype);
    setPopupConditionWin(true);
  }
  const onCloseConditionHandler = (e) => {
    setPopupConditionWin(false);
    setPopupAgreeWin(true);
  }

  //원생선택 팝업창--------------------------------------------------------
  const onChangeChildrenHandler = (e) => {
    setPopupChildrens(true);
  }
  const ClosePopupChildrens = () => {
    setPopupChildrens(false);
  }
  const SelectChildrenHandler = (ch_idx) => {
    setPopupChildrens(false);
    setChildrenIndex(ch_idx);
    localStorage.setItem('childrenIndex',ch_idx);
  }

  //클래스 상세페이지로 이동
  const onGotoClassDetailHandler = (e,cl_idx,ch_idx) => {
    navigate(`/Parents/ClassStudy/${ch_idx}/${cl_idx}`);
  }

  return isObjEmpty(varChildrenInfo)?null:(
    <>
      <div className="main-wrap">
        <div className="user-info">
          <div className="us-name">{varChildrenInfo.ch_name}</div>
          <div className="us-con">
            <div className="us-top">
              <img src={centerIcon} alt=""/>
              <p>{varChildrenInfo.bh_company}</p>
            </div>
            <div className="us-bt">{GetShotDateString(varChildrenInfo.ch_birthday)} ({varChildrenInfo.ch_gender===1?"남":"여"})</div>
          </div>
          {varChildrenList.length===1?null:<button type="button" className="us-change" onClick={e=>onChangeChildrenHandler(e)}><img src={changeIcon} alt=""/></button>}
        </div>
        {/* 수업현황 */}
        <div className="main-sec01">
          <div className="center-wrap">
            <p className="main-tit">수업현황</p>
            {varMainList.length===0?
              <div className="class-box">
                <div className="class-top">
                  <ul><li><p style={{width:"100%"}}>진행중인 수업이 없습니다.</p></li></ul>
                </div>
              </div>
            :varMainList.map((classes,i)=>(        
              <div key={'classes_'+i} className="class-box" style={{marginBottom:"10px"}} onClick={e=>onGotoClassDetailHandler(e,classes.cl_idx,classes.ch_idx)}>
                <div className="class-top">
                  <ul>
                    <li>
                      <img src={class1Icon} alt=""/>
                      <p>수업기간</p>
                      <div>{GetShotDateString(classes.sm_sdate)} ~ {GetMonthDateString(classes.sm_edate)}</div>
                    </li>
                    <li>
                      <img src={class2Icon} alt=""/>
                      <p>클래스</p>
                      <div>{classes.cl_name} ({GetClassStudyMode(classes)})</div>
                    </li>
                    <li>
                      <img src={class3Icon} alt=""/>
                      <p>레벨</p>
                      <div>{classes.vl_name}</div>
                    </li>
                  </ul>
                </div>
                <div className="class-bt">
                  <ul>
                    <li><span className="state_step">총 수업일</span><strong>{classes.tcnt}</strong></li>
                    <li><span className="state_step">잔여횟수</span><strong>{classes.rcnt}</strong></li>
                    <li><span className="state_step">출석일</span><strong>{classes.scnt}</strong></li>
                    <li><span className="state_step">결석일</span><strong>{classes.ecnt}</strong></li>
                    {/* {classes.clc_mode===0?null
                    :<li><span className="state_step">{classes.clc_mode===1?"보강일":"참여일"}</span><strong>{classes.rcnt}</strong></li>
                    } */}
                  </ul>
                </div>
              </div>
            ))}
            <Link to={'/Parents/ReinForce'} className="add-link" style={{marginTop:"10px"}}>보강신청</Link>
          </div>
        </div>

        <div className="main-sec02" style={{paddingBottom:"90px"}}>
          <div className="center-wrap">
            <p className="main-tit">마마몽떼 공지사항 <Link to={'/Parents/Notice'} className="more">더보기</Link></p>
            {varNoticeList.map((notice,i)=>(
              <div key={'notice_'+i} className="notice_box">
                <p className="notice-tit">{unescapeHtml(notice.board_title)}</p>
                <div className="notice-txt">&#9656; {unescapeHtml(notice.board_comment)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer varCurrentPage={0}/>
      <AgreeCondition varPopupAgreeWin={varPopupAgreeWin} setPopupAgreeWin={setPopupAgreeWin} onPopupConditionHandler={onPopupConditionHandler}/>
      <PopupConditions varPopupConditionWin={varPopupConditionWin} onCloseConditionHandler={onCloseConditionHandler} varConditionItem={varConditionItem}/>
      <SelectChildrens varChildrenIndex={varChildrenIndex} varPopupChildrens={varPopupChildrens} varChildrenList={varChildrenList} ClosePopupChildrens={ClosePopupChildrens} SelectChildrenHandler={SelectChildrenHandler}/>
    </>
  )
}
export default MainParent;